import {Skeleton, Stack} from '@mui/material';
import React, {Fragment} from 'react';
import {SkeletonDataProps} from './types';

const SkeletonData = ({type = 'cellPhone'}: SkeletonDataProps) => {
	const skeletonByType = {
		cellPhone: (
			<Fragment>
				<Skeleton variant="rectangular" />
				<Skeleton variant="rectangular" />
			</Fragment>
		),
		email: (
			<Fragment>
				<Skeleton variant="rectangular" />
			</Fragment>
		),
		bank: (
			<Fragment>
				<Stack direction="row" spacing={2}>
					<Skeleton variant="rectangular" width="100%" />
					<Skeleton variant="rectangular" width="100%" />
				</Stack>
				<Stack direction="row" spacing={2}>
					<Skeleton variant="rectangular" width="100%" />
					<Skeleton variant="rectangular" width="100%" />
				</Stack>
			</Fragment>
		),
		address: (
			<Stack gap={6}>
				<Skeleton variant="rectangular" height={12} />
				<Skeleton variant="rectangular" height={12} />
				<Stack direction="row" spacing={2}>
					<Skeleton variant="rectangular" width="100%" height={12} />
					<Skeleton variant="rectangular" width="100%" height={12} />
				</Stack>
				<Skeleton variant="rectangular" height={12} />
				<Skeleton variant="rectangular" height={12} />
				<Skeleton variant="rectangular" height={12} />
				<Skeleton variant="rectangular" height={12} sx={{mb: 2}} />
			</Stack>
		),
		location: (
			<Fragment>
				<Skeleton variant="rectangular" />
			</Fragment>
		),
		info: (
			<Stack gap="16px">
				<Skeleton variant="rectangular" height="26px" sx={{marginBottom: '16px'}} />
				<Stack gap="8px">
					<Skeleton variant="rectangular" height="18px" />
					<Skeleton variant="rectangular" height="18px" />
				</Stack>
				<Stack gap="4px">
					<Skeleton variant="rectangular" height="18px" />
					<Skeleton variant="rectangular" height="18px" />
				</Stack>
				<Stack gap="4px">
					<Skeleton variant="rectangular" height="18px" />
					<Skeleton variant="rectangular" height="18px" />
				</Stack>
				<Stack gap="4px">
					<Skeleton variant="rectangular" height="18px" />
					<Skeleton variant="rectangular" height="18px" />
				</Stack>
			</Stack>
		),
	};
	return (
		<Stack flex={1} gap={2} mt={1.5}>
			{skeletonByType[type]}
		</Stack>
	);
};

export {SkeletonData};
